/** Статусы поручения */
export enum OrderStatusType {
  /** Ожидает подписания */
  AwaitingSigning = 'AwaitingSigning',

  /** Новое */
  New = 'New',

  /** Ожидание Compliance-проверки */
  AwaitingComplianceCheck = 'AwaitingComplianceCheck',

  /** Compliance-проверка */
  InComplianceCheck = 'InComplianceCheck',

  /** Compliance-проверка пройдена */
  ComplianceCheckPassed = 'ComplianceCheckPassed',

  /** Ожидает отправки в АФМ */
  AwaitingAfmSubmission = 'AwaitingAfmSubmission',

  /** Отправлено в АФМ */
  SentToAfm = 'SentToAfm',

  /** В работе */
  InProgress = 'InProgress',

  /** Ожидает проверки исполнения */
  AwaitingExecutionCheck = 'AwaitingExecutionCheck',

  /** Проверка исполнения */
  ExecutionCheck = 'ExecutionCheck',

  /** Исполнено */
  Executed = 'Executed',

  /** Исполнено частично */
  PartiallyExecuted = 'PartiallyExecuted',

  /** Не исполнено */
  NotExecuted = 'NotExecuted',

  /** Отозвано */
  Revoked = 'Revoked',

  /** Отменено */
  Cancelled = 'Cancelled',
}
